var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('agency-left',{ref:"agencyLeft",staticClass:"page-left"}),_c('agency-middle',{staticClass:"page-middle",on:{"download":_vm.downloadFn}}),_c('home-right',{staticClass:"page-right"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }